import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { IInterventionCount } from 'models/Intervention';
import { call, put } from 'redux-saga/effects';

import { rikHttpClient } from 'services/httpClient';
import IGetAllInterventionRequestParams from 'services/httpClient/requests/intervention/IGetAllInterventionRequestParams';
import IGetAllInterventionResponse from 'services/httpClient/responses/intervention/IGetAllInterventionResponse';

import { interventionActions } from '../index';
import { IInterventionGetAllRequestAction } from '../reducers/getAll/request';

function* getAll(action: PayloadAction<IInterventionGetAllRequestAction>) {
  try {
    const params: IGetAllInterventionRequestParams = {
      page: action.payload.data.page,
      'filters[status]': action.payload.data.status,
      'filters[intervention_type]': action.payload.data.interventionType,
      'filters[category]': action.payload.data.category,
      'filters[custom]': action.payload.data.custom,
      intervention_ids: action.payload.data.intervention_ids,
    };

    const { data }: AxiosResponse<IGetAllInterventionResponse> = yield call(
      rikHttpClient.get,
      `interventions/${action.payload.data.id}/trader_interventions`,
      { params },
    );

    if (!data.interventions.length) {
      const countData: IInterventionCount = {
        complaint_count: data.complaint_count,
        cost_plus_date_repair_intervention_required_count:
          data.cost_plus_date_repair_intervention_required_count,
        cost_repair_intervention_planned_count:
          data.cost_repair_intervention_planned_count,
        date_inspection_required_count: data.date_inspection_required_count,
        date_repair_intervention_required_count:
          data.date_repair_intervention_required_count,
        expertise_count: data.expertise_count,
        expertise_date_required_count: data.expertise_date_required_count,
        info_client_needed_count: data.info_client_needed_count,
        info_insurer_needed_count: data.info_insurer_needed_count,
        info_pro_needed_count: data.info_pro_needed_count,
        inspection_planned_count: data.inspection_planned_count,
        leak_detection_date_required_count:
          data.leak_detection_date_required_count,
        leak_detection_planned_count: data.leak_detection_planned_count,
        new_messages: data.new_messages,
        no_cost_count: data.no_cost_count,
        paid_count: data.paid_count,
        process_invoice_count: data.process_invoice_count,
        process_leak_detection_report_count:
          data.process_leak_detection_report_count,
        quality_issue_count: data.quality_issue_count,
        quote_date_repair_intervention_required_count:
          data.quote_date_repair_intervention_required_count,
        quote_evaluation_count: data.quote_evaluation_count,
        quote_repair_intervention_planned_count:
          data.quote_repair_intervention_planned_count,
        repair_intervention_planned_count:
          data.repair_intervention_planned_count,
        trashed_count: data.trashed_count,
        urgent_date_repair_intervention_required_count:
          data.urgent_date_repair_intervention_required_count,
        urgent_repair_intervention_planned_count:
          data.urgent_repair_intervention_planned_count,
        waiting_for_invoice_count: data.waiting_for_invoice_count,
        waiting_for_leak_detection_report_count:
          data.waiting_for_leak_detection_report_count,
        waiting_for_quote_count: data.waiting_for_quote_count,
      };

      yield put(
        interventionActions.getAllSuccessWithoutData({
          message: 'noInterventionsFound',
          count: countData,
        }),
      );
      return;
    }
    yield put(interventionActions.getAllSuccessWithData(data));
  } catch (err: any) {
    action.payload.functions.error(err);
    yield put(interventionActions.getAllFailure());
  }
}

export default getAll;
